import { t } from "@lingui/macro";

import { PopUpModal } from "@whoosh/design-system/src/components/overlay/PopUpModal";
import { Text } from "@whoosh/design-system/src/components/primitive";

import { formatCountAsWord } from "./utils/formatCountAsWord";

type EmptyGroupWarningModalProps = {
  isOpen: boolean;
  onClose: (shouldConfirm?: boolean) => void;
  numberOfCreatedBookings: number;
  totalNumberOfBookings: number;
};

export const EmptyGroupWarningModal = ({
  isOpen,
  onClose,
  numberOfCreatedBookings,
  totalNumberOfBookings,
}: EmptyGroupWarningModalProps) => {
  const capitalize = (value: string) =>
    value.charAt(0).toUpperCase() + value.slice(1);

  const numberOfEmptyBookings = totalNumberOfBookings - numberOfCreatedBookings;
  const numberOfEmptyBookingsWord = formatCountAsWord(numberOfEmptyBookings);
  const numberOfCreatedBookingsWord = formatCountAsWord(
    numberOfCreatedBookings
  );
  const emptyBookingsVerb = numberOfEmptyBookings === 1 ? "has" : "have";

  const modalContent = (
    <Text color="text-secondary">
      {t`${capitalize(
        numberOfEmptyBookingsWord
      )} of your bookings ${emptyBookingsVerb} empty slots. By continuing, you will only create `}
      <Text color="text-primary">{numberOfCreatedBookingsWord}</Text>
      {t` booking${numberOfCreatedBookings === 1 ? "" : "s"}.`}
    </Text>
  );

  return (
    <PopUpModal
      isOpen={isOpen}
      onClose={onClose}
      upperTitle={t`Empty Slot`}
      content={modalContent}
      confirmText={t`Confirm and Continue`}
      cancelText={t`Back`}
    />
  );
};
